import Translator from '../../../classes/Translator/Translator';
const arrowBackLogic = () => {
  const { translator } = Translator();
  return {
    translator,
  };
};

export default arrowBackLogic;
